import type { Amount, Fx } from '@tectonics/prs/money';
import type { Maybe } from '@tectonics/utils/types';
import { CheckoutReceiptGetter, type Receipt, type ReceiptGetter } from '../types';

export const getMainReceipt: CheckoutReceiptGetter<Receipt> = ({ main }) => main;

export const getReceiptRounding: ReceiptGetter<Maybe<Amount>> = receipt => receipt.rounding;

export const getReceiptAmountExt: ReceiptGetter<Amount> = receipt => receipt.amount_ext;

export const getReceiptAmountLocalTotal: ReceiptGetter<Amount> = receipt => receipt.amount_local_total;

export const getReceiptFx: ReceiptGetter<Fx> = receipt => receipt.fx;
